import React, { useState } from "react";
import Button from "components/ui/Button";
import Modal from "components/ui/Modal";
import PropertyPicker from "components/commsLog/PropertyPicker";
import { useSendVendorGroupMessage } from "apis/commsLog";

// No template and no schedule: whatever the admin types goes straight to the group.
const VendorGroupMessage = ({ property, organizationId, onClose }) => {
  const [chosen, setChosen] = useState(property || null);
  const [text, setText] = useState("");
  const [confirming, setConfirming] = useState(false);
  const send = useSendVendorGroupMessage();

  const words = text.trim();

  const runSend = () =>
    send.mutate(
      { propertyId: chosen.propertyId, text: words },
      { onSuccess: (response) => response?.data?.success && onClose() },
    );

  return (
    <Modal isOpen onClose={onClose} title="Write to a vendor group" className="max-w-3xl">
      <div className="space-y-4">
        {!chosen ? (
          <PropertyPicker organizationId={organizationId} onPick={setChosen} />
        ) : (
          <>
            <div className="flex items-center justify-between gap-3">
              <div>
                <p className="text-sm font-semibold">{chosen.address}</p>
                <p className="text-xs text-darkgray">
                  {chosen.agentName || "No agent"} — the vendors see this from them, not
                  from Beleef.
                </p>
              </div>
              {property ? null : (
                <Button
                  className="rounded-md border border-mediumgray px-3 py-1.5 text-sm"
                  onClick={() => setChosen(null)}
                >
                  Change
                </Button>
              )}
            </div>

            <label className="flex flex-col gap-1">
              <span className="text-xs text-darkgray">What do you want to say?</span>
              <textarea
                autoFocus
                rows={10}
                className="w-full rounded-md border border-mediumgray px-3 py-2 text-sm"
                placeholder="Type the message exactly as the vendors should read it."
                value={text}
                onChange={(event) => setText(event.target.value)}
                disabled={confirming}
              />
            </label>
            <p className="text-xs text-darkgray">
              This is not a campaign message. It is not scheduled, it is not reviewed, and
              it does not appear against a template in the log.
            </p>

            {confirming ? (
              <div className="rounded-md border border-mediumgray bg-lightgray p-3">
                <p className="text-sm text-darkergray">
                  This goes into the live vendor group at {chosen.address} now, and the
                  vendors are notified. It cannot be unsent, only retracted from their
                  group.
                </p>
                <div className="mt-3 flex gap-2">
                  <Button
                    className="rounded-md bg-black px-3 py-1.5 text-sm text-white"
                    loading={send.isPending}
                    onClick={runSend}
                  >
                    Yes, send it
                  </Button>
                  <Button
                    className="rounded-md border border-mediumgray px-3 py-1.5 text-sm"
                    disabled={send.isPending}
                    onClick={() => setConfirming(false)}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            ) : (
              <div className="flex gap-2 border-t border-mediumgray pt-4">
                <Button
                  className="rounded-md bg-black px-4 py-2 text-sm text-white"
                  disabled={!words}
                  onClick={() => setConfirming(true)}
                >
                  Send to the vendor group
                </Button>
                <Button
                  className="rounded-md border border-mediumgray px-4 py-2 text-sm"
                  onClick={onClose}
                >
                  Cancel
                </Button>
              </div>
            )}
          </>
        )}
      </div>
    </Modal>
  );
};

export default VendorGroupMessage;
